"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PrimaryButton = function (props) {
    return (React.createElement("button", { type: "button", 
        // className="button primary-button"
        className: "button red-button", disabled: props.primaryDisabled, onClick: function () { return props.primaryFunction(); } }, props.primaryText));
};
exports.default = PrimaryButton;
